<script setup lang="ts">
import TagsModule from "./TagsModule.vue"
import { ref, defineProps, toRef, watch } from "vue"
import { graphql } from "~/utils/graphql"

const props = defineProps<{
  currentGenres: string[]
  trackId: string
}>()

const genres = toRef(props, "currentGenres")
const localGenres = ref<string[]>([...genres.value])

watch(genres, newValue => {
  localGenres.value = [...newValue]
})

async function onUpdate(newGenres: string[]) {
  localGenres.value = newGenres

  await graphql(
    `
    mutation SaveGenres($trackId: ID!, $genres: [String!]!) {
      setTrackGenres(trackID: $trackId, genres: $genres) {
        id
        genres
      }
    }
  `,
    { trackId: props.trackId, genres: newGenres }
  )
}
</script>

<template>
  <TagsModule label="Genres" :tags="localGenres" :track-id="trackId" @update="onUpdate" />
</template>
